export const formatTimestamp = (secondsAgo: number): string => {
  if (typeof secondsAgo == typeof "") {
    secondsAgo = Number(secondsAgo);
  }
  if (secondsAgo < 60) return `${Math.floor(secondsAgo)}s`;
  if (secondsAgo < 3600) return `${Math.floor(secondsAgo / 60)}m`;
  if (secondsAgo < 86400) return `${Math.floor(secondsAgo / 3600)}h`;
  if (secondsAgo < 172800) return "Yesterday";
  const date = new Date(Date.now() - secondsAgo * 1000);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatJoinDate = (date: string | Date | undefined): string => {
  if (!date) {
    return "";
  }
  try {
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
    });
  } catch (error) {
    console.error("Invalid date for formatting:", date, error);
    return "Invalid Date";
  }
};
